module.exports = __webpack_public_path__ + "static/media/Approval-selected-icon.7a1a2411.svg";